export default class Toast {
    toasts
    intervals
    constructor(appendPlace) {
        this.appendPlace = appendPlace || document.body
        this.toasts = []
        this.intervals = []
    }

    /**
     * Добавление в избранное, сравнение
     * @param {text} text -
     */
    message(text, link="") {
        let toast = document.createElement("div")
        toast.classList.add("toast", "wrapper", "toast-message")
        toast.innerHTML = `
            <div class="toast__content">
                <a class="toast__link" href="${link}">${text}</a>
            </div>
        `
        this.#insertToast(toast)
    }

    /**
     * Сообщение об ошибке
     * @param {*} text
     */
    error(text) {
        let toast = document.createElement("div")
        toast.classList.add("toast", "wrapper", "toast-error")
        toast.innerHTML = `
            <div class="toast__content">
                <div class="toast__title">${text}</div>
            </div>
            <div class="toast__buttons">
                <div class="toast__close"></div>
            </div>
        `
        this.#insertToast(toast)
    }


    /**
     *
     * @param {HTMLElement} toast - toast - element
     */
    #insertToast(toast) {
        document.querySelectorAll('.toast').forEach((item) => {
            item.classList.add('hide')
        })

        this.appendPlace.append(toast)
        toast.classList.add("toast-inserting")
        toast.querySelector(".toast__close")?.addEventListener("click", () => this.#removeToast(toast))
        setTimeout(() => {
            toast.classList.remove("toast-inserting")
            toast.classList.add("toast-inserted")
        }, 500)

        setTimeout(() => {
            this.#removeToast(toast)
        }, 5000)
    }

    #removeToast(toast) {
        toast.classList.remove("toast-inserted")
        toast.classList.add("toast-removing")
        setTimeout(() => {
            toast.remove()
        }, 550)
    }
}
